import React from "react";
const projectDetails = [{
  label: "Location",
  value: "\xA0Palodia, Limassol"
}, {
  label: "Year",
  value: "\xA02025"
}, {
  label: "Project Duration",
  value: "8 Months"
}];
export default function ProjectDetails() {
  return <section id="project-details" className="bg-background ![padding:0px_24px_64px_24px]">
      {}
      <div className="mx-auto max-w-4xl"> 
        <div className="grid grid-cols-1 md:grid-cols-3">
          {projectDetails.map((detail, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center md:items-center md:text-center border-b border-border py-4 md:py-0 md:border-b-0 md:border-r last:border-0 md:px-8">
              <h3 className="font-display mb-2 text-lg !text-[hsl(7,64%,38%)] !font-bold">
                {detail.label}
              </h3>
              <p className="font-sans text-foreground/80">
                {detail.value}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}